module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_9016.f6ce372f.png";